"use client";

import dynamic from "next/dynamic";

const PostHogPageView = dynamic(() => import("../../providers/posthog-pageview"), {
  ssr: false,
});

export default PostHogPageView;
